function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMLlogo87211(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "518px",
    height: "423px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M -0.5,-0.5 C 172.167,-0.5 344.833,-0.5 517.5,-0.5C 517.5,140.5 517.5,281.5 517.5,422.5C 344.833,422.5 172.167,422.5 -0.5,422.5C -0.5,281.5 -0.5,140.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0355b9",
    d: "M 280.5,132.5 C 263.854,160.081 256.521,189.747 258.5,221.5C 243.154,191.082 236.821,160.415 239.5,129.5C 242.265,114.387 248.765,101.054 259,89.5C 269.886,101.939 277.053,116.273 280.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0274c9",
    d: "M 318.5,147.5 C 290.645,166.369 270.978,191.703 259.5,223.5C 259.167,223.5 258.833,223.5 258.5,223.5C 258.5,222.833 258.5,222.167 258.5,221.5C 256.521,189.747 263.854,160.081 280.5,132.5C 290.183,118.985 302.016,107.652 316,98.5C 318.272,103.59 319.606,108.923 320,114.5C 320.83,125.571 320.33,136.571 318.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e25aa",
    d: "M 202.5,144.5 C 212.879,175.701 230.879,201.534 256.5,222C 256.272,222.399 255.938,222.565 255.5,222.5C 212.274,212.09 180.774,187.09 161,147.5C 159.29,142.587 157.457,137.753 155.5,133C 172.19,132.589 187.857,136.422 202.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0583cb",
    d: "M 259.5,223.5 C 270.978,191.703 290.645,166.369 318.5,147.5C 331.474,139.73 345.474,134.73 360.5,132.5C 355.479,164.393 339.146,188.56 311.5,205C 295.175,214.052 277.842,220.219 259.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d46ba",
    d: "M 239.5,129.5 C 236.821,160.415 243.154,191.082 258.5,221.5C 258.5,222.167 258.5,222.833 258.5,223.5C 257.209,223.737 256.209,223.404 255.5,222.5C 255.938,222.565 256.272,222.399 256.5,222C 230.879,201.534 212.879,175.701 202.5,144.5C 203.124,144.083 203.457,143.416 203.5,142.5C 200.45,127.958 199.783,113.292 201.5,98.5C 216.886,105.523 229.553,115.856 239.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1059ba",
    d: "M 123.5,243.5 C 144.263,243.784 152.097,254.118 147,274.5C 144.668,280.164 140.501,283.664 134.5,285C 123.484,287.408 115.65,283.575 111,273.5C 107.151,259.822 111.318,249.822 123.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#175bbb",
    d: "M 318.5,243.5 C 334.347,242.349 342.681,249.683 343.5,265.5C 342.103,281.388 333.437,287.888 317.5,285C 307.258,279.665 303.091,271.165 305,259.5C 306.821,251.85 311.321,246.517 318.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#145abb",
    d: "M 425.5,243.5 C 431.072,242.99 436.405,243.823 441.5,246C 445.192,248.55 446.858,252.05 446.5,256.5C 443.833,256.5 441.167,256.5 438.5,256.5C 437.768,252.213 435.101,250.213 430.5,250.5C 426.866,250.473 424.533,252.14 423.5,255.5C 423.59,257.425 424.59,258.592 426.5,259C 433.36,260.171 439.86,262.338 446,265.5C 449.659,271.887 448.826,277.72 443.5,283C 437.369,285.344 431.036,286.011 424.5,285C 418.686,282.876 415.686,278.71 415.5,272.5C 418.247,272.187 420.914,272.52 423.5,273.5C 424.128,275.258 425.128,276.758 426.5,278C 430.167,278.667 433.833,278.667 437.5,278C 440.362,276.214 441.028,273.881 439.5,271C 433.958,268.931 428.291,267.264 422.5,266C 420,264.833 418.167,263 417,260.5C 416.333,257.167 416.333,253.833 417,250.5C 419.416,247.577 422.25,245.243 425.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4482cb",
    d: "M 80.5,246.5 C 76.6002,245.57 72.6002,245.237 68.5,245.5C 68.5,258.5 68.5,271.5 68.5,284.5C 67.5044,271.344 67.1711,258.01 67.5,244.5C 72.294,243.903 76.6273,244.57 80.5,246.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0a57b9",
    d: "M 99.5,284.5 C 99.6665,273.495 99.4998,262.495 99,251.5C 98.2086,252.745 97.7086,254.078 97.5,255.5C 95.5,265.167 93.5,274.833 91.5,284.5C 88.5,284.5 85.5,284.5 82.5,284.5C 80.6544,273.456 78.4877,262.456 76,251.5C 75.5002,262.495 75.3335,273.495 75.5,284.5C 73.1667,284.5 70.8333,284.5 68.5,284.5C 68.5,271.5 68.5,258.5 68.5,245.5C 72.6002,245.237 76.6002,245.57 80.5,246.5C 82.6652,256.153 84.8319,265.82 87,275.5C 89.6012,265.59 92.1012,255.59 94.5,245.5C 98.4454,244.509 102.445,244.176 106.5,244.5C 106.5,257.833 106.5,271.167 106.5,284.5C 104.167,284.5 101.833,284.5 99.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0555b9",
    d: "M 175.5,272.5 C 176.493,263.682 176.827,254.682 176.5,245.5C 178.833,245.5 181.167,245.5 183.5,245.5C 183.5,255.167 183.5,264.833 183.5,274.5C 183.104,280.731 179.77,284.231 173.5,285C 167.903,286.091 162.57,285.424 157.5,283C 155.19,281.363 153.69,279.196 153,276.5C 152.5,265.839 152.333,255.172 152.5,244.5C 155.167,244.5 157.833,244.5 160.5,244.5C 160.071,255.245 160.571,265.912 162,276.5C 166.591,279.367 170.924,279.034 175,275.5C 175.483,274.552 175.649,273.552 175.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d7dc9",
    d: "M 183.5,274.5 C 183.5,264.833 183.5,255.167 183.5,245.5C 181.167,245.5 178.833,245.5 176.5,245.5C 176.827,254.682 176.493,263.682 175.5,272.5C 175.5,263.167 175.5,253.833 175.5,244.5C 178.5,244.5 181.5,244.5 184.5,244.5C 184.827,254.681 184.494,264.681 183.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0f59ba",
    d: "M 187.5,244.5 C 190.777,244.216 193.943,244.549 197,245.5C 202,254.167 207,262.833 212,271.5C 212.5,262.506 212.666,253.506 212.5,244.5C 215.167,244.5 217.833,244.5 220.5,244.5C 220.5,257.833 220.5,271.167 220.5,284.5C 217.428,284.817 214.428,284.484 211.5,283.5C 206.333,274.5 201.167,265.5 196,256.5C 195.5,265.827 195.334,275.161 195.5,284.5C 192.833,284.5 190.167,284.5 187.5,284.5C 187.5,271.167 187.5,257.833 187.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#185cbc",
    d: "M 223.5,244.5 C 234.5,244.5 245.5,244.5 256.5,244.5C 256.5,246.833 256.5,249.167 256.5,251.5C 252.5,251.5 248.5,251.5 244.5,251.5C 244.5,262.5 244.5,273.5 244.5,284.5C 241.5,284.5 238.5,284.5 235.5,284.5C 235.5,273.5 235.5,262.5 235.5,251.5C 231.5,251.5 227.5,251.5 223.5,251.5C 223.5,249.167 223.5,246.833 223.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0155b9",
    d: "M 276.5,244.5 C 279.167,244.5 281.833,244.5 284.5,244.5C 284.5,255.5 284.5,266.5 284.5,277.5C 291.167,277.5 297.833,277.5 304.5,277.5C 304.5,279.833 304.5,282.167 304.5,284.5C 295.167,284.5 285.833,284.5 276.5,284.5C 276.5,271.167 276.5,257.833 276.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0356b9",
    d: "M 375.5,251.5 C 371.5,251.5 367.5,251.5 363.5,251.5C 363.5,262.5 363.5,273.5 363.5,284.5C 360.833,284.5 358.167,284.5 355.5,284.5C 355.5,273.5 355.5,262.5 355.5,251.5C 351.5,251.5 347.5,251.5 343.5,251.5C 343.5,249.167 343.5,246.833 343.5,244.5C 354.167,244.5 364.833,244.5 375.5,244.5C 375.5,246.833 375.5,249.167 375.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1559bb",
    d: "M 379.5,244.5 C 382.5,244.5 385.5,244.5 388.5,244.5C 388.334,254.506 388.5,264.506 389,274.5C 390.018,277.683 392.185,279.016 395.5,278.5C 398.933,278.867 401.433,277.534 403,274.5C 403.5,264.506 403.666,254.506 403.5,244.5C 406.167,244.5 408.833,244.5 411.5,244.5C 411.933,255.91 411.433,267.244 410,278.5C 406.534,283.888 401.534,286.221 395,285.5C 387.984,285.809 382.984,282.809 380,276.5C 379.5,265.839 379.333,255.172 379.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8fafd",
    d: "M 125.5,250.5 C 133.182,249.68 138.015,253.013 140,260.5C 141.366,267.745 139.199,273.578 133.5,278C 127.938,279.581 123.438,278.081 120,273.5C 118.582,268.572 118.249,263.572 119,258.5C 120.305,255.039 122.471,252.372 125.5,250.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafcfd",
    d: "M 320.5,250.5 C 326.739,249.536 331.239,251.869 334,257.5C 335.127,263.755 334.46,269.755 332,275.5C 325.618,280.077 319.951,279.41 315,273.5C 313.582,268.572 313.249,263.572 314,258.5C 315.305,255.039 317.471,252.372 320.5,250.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5991d1",
    d: "M 99.5,284.5 C 98.8333,274.833 98.1667,265.167 97.5,255.5C 97.7086,254.078 98.2086,252.745 99,251.5C 99.4998,262.495 99.6665,273.495 99.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c4d7ee",
    d: "M 375.5,251.5 C 372.038,252.482 368.371,252.815 364.5,252.5C 364.828,263.346 364.494,274.013 363.5,284.5C 363.5,273.5 363.5,262.5 363.5,251.5C 367.5,251.5 371.5,251.5 375.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b7acb",
    d: "M 117.5,299.5 C 113.427,301.135 109.094,302.135 104.5,302.5C 104.5,304.5 104.5,306.5 104.5,308.5C 108.768,308.869 112.768,309.869 116.5,311.5C 112.5,311.5 108.5,311.5 104.5,311.5C 104.5,314.167 104.5,316.833 104.5,319.5C 109.167,319.5 113.833,319.5 118.5,319.5C 118.5,320.5 118.5,321.5 118.5,322.5C 112.833,322.5 107.167,322.5 101.5,322.5C 101.5,314.833 101.5,307.167 101.5,299.5C 106.833,299.5 112.167,299.5 117.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#247ecd",
    d: "M 120.5,299.5 C 122.39,299.297 123.89,299.963 125,301.5C 126.271,304.433 127.938,307.099 130,309.5C 132.29,306.42 134.457,303.253 136.5,300C 137.635,299.251 138.635,299.417 139.5,300.5C 136.75,304.332 134.25,308.332 132,312.5C 131.502,315.817 131.335,319.15 131.5,322.5C 130.5,322.5 129.5,322.5 128.5,322.5C 128.665,319.15 128.498,315.817 128,312.5C 125.477,308.112 122.977,303.778 120.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1c7bcb",
    d: "M 158.5,299.5 C 154.427,301.135 150.094,302.135 145.5,302.5C 145.5,304.5 145.5,306.5 145.5,308.5C 149.353,309.166 153.353,309.833 157.5,310.5C 153.555,311.491 149.555,311.824 145.5,311.5C 145.5,314.167 145.5,316.833 145.5,319.5C 150.167,319.5 154.833,319.5 159.5,319.5C 159.5,320.5 159.5,321.5 159.5,322.5C 153.833,322.5 148.167,322.5 142.5,322.5C 142.5,314.833 142.5,307.167 142.5,299.5C 147.833,299.5 153.167,299.5 158.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2880ce",
    d: "M 175.5,299.5 C 181.496,298.333 183.996,300.666 183,306.5C 178.72,308.972 178.72,311.639 183,314.5C 183.483,313.552 183.649,312.552 183.5,311.5C 184.5,311.5 185.5,311.5 186.5,311.5C 184.635,315.37 185.302,318.704 188.5,321.5C 188,321.833 187.5,322.167 187,322.5C 185.667,321.833 184.333,321.167 183,320.5C 173.999,325.009 169.999,322.343 171,312.5C 172.298,311.44 173.465,310.274 174.5,309C 171.668,305.496 172.001,302.33 175.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d81ce",
    d: "M 200.5,299.5 C 205.833,299.5 211.167,299.5 216.5,299.5C 216.5,300.5 216.5,301.5 216.5,302.5C 212.167,302.5 207.833,302.5 203.5,302.5C 203.5,304.5 203.5,306.5 203.5,308.5C 207.5,308.5 211.5,308.5 215.5,308.5C 215.5,309.5 215.5,310.5 215.5,311.5C 211.5,311.5 207.5,311.5 203.5,311.5C 203.5,314.167 203.5,316.833 203.5,319.5C 207.833,319.5 212.167,319.5 216.5,319.5C 211.604,321.446 206.271,322.113 200.5,321.5C 200.5,314.167 200.5,306.833 200.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f7dcc",
    d: "M 220.5,299.5 C 222.144,299.286 223.644,299.62 225,300.5C 228.585,306.002 231.919,311.669 235,317.5C 235.499,311.509 235.666,305.509 235.5,299.5C 236.5,299.5 237.5,299.5 238.5,299.5C 238.5,307.167 238.5,314.833 238.5,322.5C 237.022,322.762 235.689,322.429 234.5,321.5C 231,315.833 227.5,310.167 224,304.5C 223.501,310.491 223.334,316.491 223.5,322.5C 222.5,322.5 221.5,322.5 220.5,322.5C 220.5,314.833 220.5,307.167 220.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d7bcc",
    d: "M 240.5,299.5 C 246.833,299.5 253.167,299.5 259.5,299.5C 259.5,300.5 259.5,301.5 259.5,302.5C 256.833,302.5 254.167,302.5 251.5,302.5C 251.5,309.167 251.5,315.833 251.5,322.5C 250.5,322.5 249.5,322.5 248.5,322.5C 248.5,315.5 248.5,308.5 248.5,301.5C 245.302,302.036 242.635,301.369 240.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1179cb",
    d: "M 269.5,299.5 C 270.5,299.5 271.5,299.5 272.5,299.5C 272.5,302.5 272.5,305.5 272.5,308.5C 276.5,308.5 280.5,308.5 284.5,308.5C 284.5,305.5 284.5,302.5 284.5,299.5C 285.5,299.5 286.5,299.5 287.5,299.5C 287.5,307.167 287.5,314.833 287.5,322.5C 286.5,322.5 285.5,322.5 284.5,322.5C 284.5,318.833 284.5,315.167 284.5,311.5C 280.5,311.5 276.5,311.5 272.5,311.5C 272.5,315.167 272.5,318.833 272.5,322.5C 271.5,322.5 270.5,322.5 269.5,322.5C 269.5,314.833 269.5,307.167 269.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#247fcd",
    d: "M 298.5,298.5 C 309.793,298.636 314.293,304.303 312,315.5C 309.136,321.689 304.303,323.856 297.5,322C 290.288,316.879 288.788,310.379 293,302.5C 294.812,301.023 296.645,299.69 298.5,298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e83cf",
    d: "M 320.5,298.5 C 323.607,298.351 326.607,298.851 329.5,300C 331.607,301.264 332.607,303.097 332.5,305.5C 329.97,303.408 326.97,302.074 323.5,301.5C 318.502,302.016 317.502,304.182 320.5,308C 325.39,308.293 329.557,310.126 333,313.5C 333.755,316.497 332.922,318.997 330.5,321C 325.889,323.116 321.389,322.949 317,320.5C 315.872,318.655 315.372,316.655 315.5,314.5C 316.5,314.5 317.5,314.5 318.5,314.5C 318.227,316.451 318.893,317.951 320.5,319C 323.167,319.667 325.833,319.667 328.5,319C 331.326,316.478 330.993,314.478 327.5,313C 323.791,312.367 320.291,311.2 317,309.5C 314.718,304.732 315.885,301.065 320.5,298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#187bcc",
    d: "M 336.5,299.5 C 341.179,299.334 345.845,299.501 350.5,300C 354.032,303.39 354.366,307.057 351.5,311C 347.637,312.354 343.637,312.854 339.5,312.5C 339.5,315.833 339.5,319.167 339.5,322.5C 338.5,322.5 337.5,322.5 336.5,322.5C 336.5,314.833 336.5,307.167 336.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0975c9",
    d: "M 357.5,299.5 C 358.5,299.5 359.5,299.5 360.5,299.5C 360.5,307.167 360.5,314.833 360.5,322.5C 359.5,322.5 358.5,322.5 357.5,322.5C 357.5,314.833 357.5,307.167 357.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0073c9",
    d: "M 380.5,299.5 C 378.365,301.369 375.698,302.036 372.5,301.5C 371.833,328.167 371.167,328.167 370.5,301.5C 367.833,301.5 365.167,301.5 362.5,301.5C 368.074,299.547 374.074,298.88 380.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2a81ce",
    d: "M 385.5,299.5 C 387.144,299.286 388.644,299.62 390,300.5C 392.808,307.757 395.308,315.09 397.5,322.5C 396.325,322.719 395.325,322.386 394.5,321.5C 393.833,319.833 393.167,318.167 392.5,316.5C 389.167,315.167 385.833,315.167 382.5,316.5C 381.652,318.409 381.318,320.409 381.5,322.5C 380.022,322.762 378.689,322.429 377.5,321.5C 380.371,314.22 383.037,306.886 385.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d7fce",
    d: "M 400.5,299.5 C 401.5,299.5 402.5,299.5 403.5,299.5C 403.5,306.167 403.5,312.833 403.5,319.5C 407.649,318.92 411.316,319.586 414.5,321.5C 409.833,321.5 405.167,321.5 400.5,321.5C 400.5,314.167 400.5,306.833 400.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#74b3e2",
    d: "M 117.5,299.5 C 118.404,300.209 118.737,301.209 118.5,302.5C 113.833,302.5 109.167,302.5 104.5,302.5C 109.094,302.135 113.427,301.135 117.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#72b2e2",
    d: "M 158.5,299.5 C 159.404,300.209 159.737,301.209 159.5,302.5C 154.833,302.5 150.167,302.5 145.5,302.5C 150.094,302.135 154.427,301.135 158.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8fbfd",
    d: "M 298.5,301.5 C 307.649,301.156 311.149,305.49 309,314.5C 306.565,319.224 302.731,320.724 297.5,319C 292.024,312.83 292.358,306.997 298.5,301.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#86bce5",
    d: "M 348.5,302.5 C 345.833,302.5 343.167,302.5 340.5,302.5C 340.5,304.833 340.5,307.167 340.5,309.5C 342.833,309.5 345.167,309.5 347.5,309.5C 345.052,310.473 342.385,310.806 339.5,310.5C 339.5,307.5 339.5,304.5 339.5,301.5C 342.713,301.19 345.713,301.523 348.5,302.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5f0f9",
    d: "M 176.5,301.5 C 180.35,301.701 181.35,303.534 179.5,307C 175.83,306.836 174.83,305.003 176.5,301.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfdfe",
    d: "M 348.5,302.5 C 349.88,302.962 350.547,303.962 350.5,305.5C 350.439,307.653 349.439,308.986 347.5,309.5C 345.167,309.5 342.833,309.5 340.5,309.5C 340.5,307.167 340.5,304.833 340.5,302.5C 343.167,302.5 345.833,302.5 348.5,302.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#71addf",
    d: "M 380.5,299.5 C 381.404,300.209 381.737,301.209 381.5,302.5C 378.833,302.5 376.167,302.5 373.5,302.5C 373.5,309.167 373.5,315.833 373.5,322.5C 372.167,322.5 370.833,322.5 369.5,322.5C 369.5,315.833 369.5,309.167 369.5,302.5C 366.941,302.802 364.607,302.468 362.5,301.5C 365.167,301.5 367.833,301.5 370.5,301.5C 371.167,328.167 371.833,328.167 372.5,301.5C 375.698,302.036 378.365,301.369 380.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8f1f9",
    d: "M 386.5,303.5 C 389.126,305.764 390.459,308.764 390.5,312.5C 388.5,312.5 386.5,312.5 384.5,312.5C 385.167,309.5 385.833,306.5 386.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#76b5e3",
    d: "M 104.5,308.5 C 108.833,308.5 113.167,308.5 117.5,308.5C 117.737,309.791 117.404,310.791 116.5,311.5C 112.768,309.869 108.768,308.869 104.5,308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b7d6ef",
    d: "M 145.5,308.5 C 149.833,308.5 154.167,308.5 158.5,308.5C 158.5,309.833 158.5,311.167 158.5,312.5C 154.5,312.5 150.5,312.5 146.5,312.5C 146.5,314.5 146.5,316.5 146.5,318.5C 151.032,318.182 155.366,318.515 159.5,319.5C 154.833,319.5 150.167,319.5 145.5,319.5C 145.5,316.833 145.5,314.167 145.5,311.5C 149.555,311.824 153.555,311.491 157.5,310.5C 153.353,309.833 149.353,309.166 145.5,308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edf4fa",
    d: "M 175.5,311.5 C 177.916,312.916 179.916,314.916 181.5,317.5C 177.794,321.771 174.794,321.271 172.5,316C 173.315,314.357 174.315,312.857 175.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6aaedf",
    d: "M 400.5,299.5 C 400.5,306.833 400.5,314.167 400.5,321.5C 405.167,321.5 409.833,321.5 414.5,321.5C 409.695,322.487 404.695,322.821 399.5,322.5C 399.175,314.648 399.508,306.982 400.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7eb9e3",
    d: "M 200.5,299.5 C 200.5,306.833 200.5,314.167 200.5,321.5C 206.271,322.113 211.604,321.446 216.5,319.5C 217.404,320.209 217.737,321.209 217.5,322.5C 211.5,322.5 205.5,322.5 199.5,322.5C 199.175,314.648 199.508,306.982 200.5,299.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLlogo87211);
export default __webpack_public_path__ + "static/media/ML logo8-7-21-1.ddbead8d5da6b75b0180418500d6f644.svg";
export { ForwardRef as ReactComponent };